<template>
  <el-row>
    <template v-for="(application, index) in $navigation.applications">
      <router-link
        v-if="!application.hidden"
        :key="index"
        :to="application.route"
        class="el-col el-col-8"
      >
        <component :is="application.icon" />
        <h4>{{ application.name }}</h4>
      </router-link>
    </template>
  </el-row>
</template>

<script>
export default {
  //
}
</script>

<style lang="scss" scoped>
  @import 'variables';

  .el-col {
    cursor: pointer;
    border-radius: 5px;
    transition: .1s;
    text-align: center;
    padding: 20px 15px;

    &:hover {
      background-color: $lighter;
    }

    > h4 {
      font-size: 0.75rem;
    }

    > svg {
      width: 56px;
      height: 56px;
    }
  }
</style>
